import { createReducer, on } from '@ngrx/store';

import * as UserActions from './user.actions';
import { IUserState } from '../../core/interfaces/user.interface';

export const initialUserState: IUserState = {
    loggedInUser: null,
};

export const userReducer = createReducer(
    initialUserState,
    on(UserActions.setLoggedInUser, (state, { user }) => ({
        ...state,
        loggedInUser: user,
    })),
);
